// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"StatusSwitcher_wrapper__036Gm","button":"StatusSwitcher_button__yL_nl","completed":"StatusSwitcher_completed__D1ItX"};